import React, { useState } from "react";

import classNames from "classnames";
import PropTypes from "prop-types";

import DonationBoxDefault from "./donationBoxDefault";
import DonationBoxLinks from "./donationBoxLinks";
import DonationBoxToggle from "./donationBoxToggle";

import "./donationBox.scss";

const getDonationBoxVariant = (variant, options) => {
  switch (variant) {
    case "links":
      return (<DonationBoxLinks {...options} />);
    case "toggle":
      return (<DonationBoxToggle {...options} />);
    default:
      return (<DonationBoxDefault {...options} />);
  }
};

const DonationBox = ({
  className = undefined,
  title,
  text = undefined,
  contactLink,
  sepaAmount,
  variant: overwriteVariant = undefined,
  ...furtherProps
}) => {
  const [showHeadline, setShowHeadline] = useState(true);

  let variant = "default";

  switch (process.env.GATSBY_SITE) {
    case "us":
    case "cl":
    case "in":
      variant = "links";
      break;
    default:
  }

  variant = overwriteVariant || variant;

  return (
    <div
      className={classNames(
        "donation-box",
        [`donation-box--${variant}`],
        className,
      )}
    >
      <div className="donation-box__inner">
        {showHeadline && (
          <>
            {title && (
              <div className="donation-box__title">
                {title}
              </div>
            )}
            {text && (
              <div className="donation-box__text">
                {text}
              </div>
            )}
          </>
        )}
        {getDonationBoxVariant(variant, {
          ...furtherProps,
          showHeadline: setShowHeadline,
        })}
      </div>
    </div>
  );
};

DonationBox.propTypes = {
  ...DonationBoxLinks.propTypes,
  ...DonationBoxToggle.propTypes,
  ...DonationBoxDefault.propTypes,
  className: PropTypes.string,
  contactLink: PropTypes.string.isRequired,
  text: PropTypes.string,
  title: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(["default", "links", "toggle"]),
};

export default DonationBox;
